module.exports = __webpack_public_path__ + "img/qcs.4e11cbdd.png";